<div class="d-flex justify-content-between" [ngClass]="styleClass">
  <label [for]="for">
    {{ title }}
    <span class="text-danger" *ngIf="isRequired">*</span>
  </label>

  <span
    *ngIf="tooltipText !== '' && ismovil"
    [pTooltip]="tooltipContent"
    tabindex="0"
    tooltipEvent="focus"
    style="outline: 0"
    class="toltip"
  >
    <em class="pi pi-info" [rounded]="true" severity="success"></em>
  </span>

  <p-button
    *ngIf="tooltipText !== '' && !ismovil"
    icon="pi pi-info"
    [rounded]="true"
    severity="success"
    styleClass="toltip"
    [pTooltip]="tooltipContent"
  ></p-button>
</div>

<ng-template #tooltipContent>
  <div class="flex align-items-center" style="font-size: 12px">
    {{ tooltipText }}
  </div>
</ng-template>
